import React, { useRef, useState } from "react";
import '../css/navbar.css';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const navRef = useRef();
  const [menuOpen, setMenuOpen] = useState(false);
  const [transparentBackground, setTransparentBackground] = useState(false);
  const [showSambutan, setShowSambutan] = useState(false);
  const [showInformasi, setShowInformasi] = useState(false);
  const [showOrganisasi, setShowOrganisasi] = useState(false);
  const handleClick = (menu) => {
    setActiveMenu(menu === activeMenu ? null : menu);
  };
  const [activeMenu, setActiveMenu] = useState(null);

  const showNavbar = () => {
    setMenuOpen(!menuOpen);
    setTransparentBackground(!transparentBackground);
  };

  const closeNavbar = () => {
    setMenuOpen(false);
    setTransparentBackground(false);
    setShowSambutan(false);
    setShowInformasi(false);
    setShowOrganisasi(false);
  };

  const handleProfilSekolahClick = () => {
    setShowSambutan(true);
    setShowInformasi(false);
    setShowOrganisasi(false);
    handleClick('profil');
  };

  const handleInformasiClick = () => {
    setShowInformasi(true);
    setShowOrganisasi(false);
    setShowSambutan(false);
    handleClick('informasi');
  };

  const handleOrganisasiClick = () => {
    setShowOrganisasi(true);
    setShowInformasi(false);
    setShowSambutan(false);
    handleClick('organisasi');
  };

  return (
    <header className={`header ${transparentBackground ? 'transparent-bg' : ''}`}>
      <a href="/" >
        <img src="../../assets/navbar/UM.svg" alt="LOGO" className={`logo ${menuOpen ? 'hidden' : ''}`} />
      </a>

      <div className={`menu ${menuOpen ? 'menu-open' : ''}`}>
        {/* <img src="../../assets/navbar/search.svg" alt="Search" className={`search-icon1 ${menuOpen ? 'hidden' : ''}`} /> */}
        <button className={`ppdb ${menuOpen ? 'hidden' : ''}`}>PPDB</button>

        <nav ref={navRef} className={`nav-links ${menuOpen ? 'responsive_nav' : ''}`}>
          <div className="respon">
            <a href="/">
              <img src="../../assets/navbar/responsive.svg" alt="LOGO" className="logo" />
            </a>

            <div className="respon-kanan">
              {/* <img src="../../assets/navbar/search.svg" alt="Search" className="search-icon2" /> */}
              <button className="ppdb2">PPDB</button>
              <button
                className="nav-btn nav-close-btn"
                onClick={closeNavbar}>
                Kembali
                <img src="../../assets/navbar/menu-close.svg" alt="Close" className="close-icon" />
              </button>
            </div>
          </div>

          <div className="cover-menu d-flex justify-content-start">
            <div className="menu-kiri" style={{ cursor: "pointer" }}>
              <div className={`nav-link ${activeMenu === 'profil' ? 'click' : ''}`} onClick={handleProfilSekolahClick}>Profil Sekolah</div>
              <div className={`nav-link ${activeMenu === 'informasi' ? 'click' : ''}`} onClick={handleInformasiClick}>Informasi</div>
              <div className={`nav-link ${activeMenu === 'organisasi' ? 'click' : ''}`} onClick={handleOrganisasiClick}>Organisasi</div>
              <a href="/#" className="nav-link">Galeri</a>
              <a href="/#" className="nav-link">Ekstrakulikuler</a>
              <a href="/#" className="nav-link">Inovasi Mengajar</a>
            </div>
            {showSambutan && (
              <div className="sambutan">
                <Link to="/sambutan" className="nav-link">
                  Sambutan
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </Link>
                <a href="/#" className="nav-link">
                  Tentang SMA Lab UM
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Struktur Organigram
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Guru & Karyawan
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Statistika
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Logo
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
              </div>
            )}


            {showInformasi && (
              <div className="sambutan">
                <Link to="/berita" className="nav-link">
                  Berita
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </Link>
                <a href="/#" className="nav-link">
                  Agenda
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Pengumuman
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
              </div>
            )}


            {showOrganisasi && (
              <div className="sambutan">
                <a href="/#" className="nav-link">
                  OSIS
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  Pramuka
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
                <a href="/#" className="nav-link">
                  PMR
                  <img src="../../assets/navbar/arrow-right.svg" className="next"></img>
                </a>
              </div>
            )}
          </div>
        </nav>
        <button
          className={`nav-btn ${menuOpen ? 'hidden' : ''}`}
          onClick={showNavbar}>
          Menu
          <img src="../../assets/navbar/menu-open.svg" alt="Menu" className="menu-icon" />
        </button>
      </div>
    </header>
  );
}
